import React from "react";
import "./Overview.css";
import { ArrowRight } from "lucide-react";

export default function Overview() {
const stats = [
  {
    title: "Active Incentives",
    value: "26",
    icon: "fa-solid fa-gift",
    bg: "#E6F7F4",
    trend: "+8%",
    trendType: "up",
  },
  {
    title: "Scheduled",
    value: "8",
    icon: "fa-solid fa-calendar",
    bg: "#F3E8FF",
    trend: "+14%",
    trendType: "up",
  },
  {
    title: "Draft",
    value: "5",
    icon: "fa-solid fa-file",
    bg: "#FFF4E5",
    trend: "No Change",
    trendType: "neutral",
  },
  {
    title: "Expired",
    value: "14",
    icon: "fa-solid fa-clock",
    bg: "#FDEAEA",
    trend: "-5%",
    trendType: "down",
  },
  {
    title: "Total Redemptions",
    value: "2,483",
    icon: "fa-solid fa-ticket",
    bg: "#E6F7F4",
    trend: "+18%",
    trendType: "up",
  },
  {
    title: "Budget Consumed",
    value: "68%",
    icon: "fa-solid fa-chart-pie",
    bg: "#FFF4E5",
    trend: "+5%",
    trendType: "up",
  },
  {
    title: "Profit Saved",
    value: "1,248 EGP",
    icon: "fa-solid fa-coins",
    bg: "#E8FBF8",
    trend: "+9%",
    trendType: "up",
  },
  {
    title: "Currently Paused",
    value: "6",
    icon: "fa-solid fa-pause",
    bg: "#FFF4E5",
    trend: "+1%",
    trendType: "up",
  },
  {
    title: "Pending Approval",
    value: "12",
    icon: "fa-solid fa-hourglass-half",
    bg: "#F3E8FF",
    trend: "+9%",
    trendType: "up",
  },
  {
    title: "Failed Redemptions",
    value: "37",
    icon: "fa-solid fa-xmark",
    bg: "#FDEAEA",
    trend: "+5%",
    trendType: "down",
  },
];

  return (
    <div className="overview">
      {/* HEADER */}
      <div className="header">
        <div className="header-left">
          <input
            className="search"
            placeholder="Search incentive, codes, orders"
          />
        </div>

        <div className="header-right">
          <button className="btn create">
            <i className="fa-solid fa-plus"></i>
            Create Incentive
          </button>

          <button className="btn light">
            <i className="fa-regular fa-circle-play"></i>
            Simulation Mode
          </button>

          <button className="btn light">
            <i className="fa-solid fa-download"></i>
            Export Report
          </button>

          <button className="btn dangerr">
            <i className="fa-solid fa-power-off"></i>
            Emergency Freeze
          </button>
        </div>
      </div>
      {/* STATS */}
      <div className="stats-grid">
        {stats.map((item, i) => (
          <div className="stat-card" key={i}>
            <div className="stat-top">
              <div className="stat-icon" style={{ backgroundColor: item.bg }}>
                <i className={item.icon}></i>
              </div>

              <span className="stat-title">{item.title}</span>
            </div>

            <div className="stat-value">{item.value}</div>

            <div className="stat-bottom">
              <span className={`trend ${item.trendType}`}>{item.trend}</span>
              <span className="trend-text">vs last 30 days</span>
            </div>
          </div>
        ))}
      </div>
      {/* TABLE */}
      <div className="table-card">
        <div className="overview-table-header">
          <h3>Active Campaign Performance</h3>
          <span className="view-all">
            View all incentives <ArrowRight size={18} />
          </span>
        </div>
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Incentive Name</th>
                <th>Type</th>
                <th>Redemption</th>
                <th>Budget Used</th>
                <th>Funding Source</th>
                <th>Net Impact</th>
                <th>Conversion Rate</th>
                <th>Avg Order List</th>
                <th>Margin Status</th>
                <th>Last Redemption</th>
                <th>Status</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="name-cell">
                  <div className="avatar yellow">%</div>
                  <div>
                    <div className="name">Weekend Oil Offer</div>
                  </div>
                </td>
                <td>Offer</td>
                <td>624</td>
                <td>
                  <div className="progress">
                    <div
                      className="progress-bar green"
                      style={{ width: "72%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="dot green"></span> Healthy
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
              {/* ROW 2 */}
              <tr>
                <td className="name-cell">
                  <div className="avatar black">%</div>
                  <div className="name">Welcome 2026</div>
                </td>
                <td>Promo Code</td>
                <td>405</td>
                <td>
                  <div className="progress">
                    <div
                      className="progress-bar yellow"
                      style={{ width: "58%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="dot green"></span> Healthy
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
              {/* ROW 3 */}
              <tr>
                <td className="name-cell">
                  <div className="avatar teal">%</div>
                  <div className="name">Competition 100</div>
                </td>
                <td>Coupon</td>
                <td>112</td>
                <td>
                  <div className="progress">
                    <div
                      className="progress-bar red"
                      style={{ width: "34%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="dot yellow"></span> Medium
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* CHARTS SECTION */}
      <div className="grid-3">
        <div className="card chart">
          <div className="chart-title">Budget Usage</div>
          <div className="overview-circle">
            <span>68%</span>
          </div>
        </div>

        <div className="card chart">
          <div className="chart-title">Redemption Trend</div>
          <div className="fake-chart"></div>
        </div>

        <div className="card chart">
          <div className="chart-title">Priority Rules</div>
          <ul className="rules">
            <li>One Offer per Order</li>
            <li>Taxes Excluded</li>
            <li>Doorstep Fee Excluded</li>
          </ul>
        </div>
      </div>
      {/* BOTTOM */}
      <div className="grid-3">
        <div className="card">
          <div className="card-header">Highest ROI</div>
          <div className="bar">
            <span>Weekend Offer</span>
            <div className="bar-line green" />
          </div>
        </div>

        <div className="card">
          <div className="card-header">Most Abused</div>
          <div className="bar">
            <span>Welcome2026</span>
            <div className="bar-line red" />
          </div>
        </div>

        <div className="card">
          <div className="card-header">Alerts</div>
          <div className="alert warning">Budget reached 85%</div>
          <div className="alert error">Order blocked</div>
        </div>
      </div>
    </div>
  );
}
